<template>
  <div class="preview-effect">
    <div
      class="preview-effect__image"
      :style="{ backgroundImage: `url(${current.src})` }"
    >
      <span class="preview-effect__image-order">{{ current.order }}</span>
    </div>

    <div class="mockup__input">
      <label for="">Mix Blend Mode:</label>
      <select
        class="mockup__select-order flex-1"
        v-model="current.mixBlendMode"
      >
        <option v-for="(item, o) in blendModes" :key="o" :value="item">{{
          item
        }}</option>
      </select>
    </div>

    <div class="mockup__input">
      <label for="">Opacity: {{ current.opacity }}</label>
      <input
        type="range"
        v-model.number="current.opacity"
        step="0.01"
        min="0"
        max="1"
      />
    </div>

    <div class="preview-effect__header">
      <slot name="order"></slot>
      <div
        class="mockup__btn-icon"
        :class="current.destroy ? 'mockup__btn-icon--active' : ''"
        @click="current.destroy = !current.destroy"
      >
        <icon-trash />
      </div>
    </div>
  </div>
</template>

<script>
import IconTrash from "@gocasebr/go-shared/dist/trash/Trash";

export default {
  components: { IconTrash },
  props: { current: Object },
  data() {
    return {
      blendModes: [
        "normal",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity",
        "initial",
        "inherit",
        "unset",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.preview-effect {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: none;
  cursor: grab;
  padding: 6px;
  margin-bottom: 6px;
  border: 1px solid #f2f2f4;

  .mockup__input {
    width: 100%;
  }

  .preview-effect__header {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 6px;
  }

  .preview-effect__image {
    width: 200px;
    height: 200px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    text-shadow: 0px 0px 5px #ec8ab3;
    color: #fff;
  }
}
</style>
